export default __webpack_public_path__ + "73b0687d76af9774aac031711361225a.ttf";